import cx from 'classnames'

import { getInitials } from 'utils'
import { ShareTwo } from 'almanac-ui/icons'
import { ReactComponent as EditIcon } from 'assets/icons/edit16.svg'
import Avatar from 'common/Avatar/Avatar'
import { RecipientsSelectorValueType } from 'types'
import { AccessorAvatarProps } from '../Types'
import Styles from '../ShareSheet.module.scss'

export const AccessorAvatar = ({ type, avatarUrl, name, size = 20 }: AccessorAvatarProps) => {
  if (
    !!type &&
    !avatarUrl &&
    [
      RecipientsSelectorValueType.Company,
      RecipientsSelectorValueType.EveryoneAtWorkspace,
      RecipientsSelectorValueType.Channel,
    ].includes(type)
  )
    return (
      <div className={cx(Styles.groupIcon, { [Styles.large]: size === 24 })}>
        <ShareTwo size={size - 4} color={Styles.grey40} />
      </div>
    )

  if (type === RecipientsSelectorValueType.LayerEditors) {
    return (
      <div className={cx(Styles.groupIcon, { [Styles.large]: size === 24 })}>
        <EditIcon />
      </div>
    )
  }

  return <Avatar url={avatarUrl} label={getInitials(name)} size={size} staticColor />
}
